import { formatPercentage } from "../utils/recipeAddIngredient.utils";

interface IngredientCapacityStatusProps {
  remaining: number;
  savedTotal: number;
  pendingTotal: number;
}

const IngredientCapacityStatus = ({
  remaining,
  savedTotal,
  pendingTotal
}: IngredientCapacityStatusProps) => {
  return (
    <>
      Remaining capacity:{" "}
      <span className={`tw-font-semibold ${remaining === 0 ? "tw-text-warning" : "tw-text-primary"}`}>{formatPercentage(remaining)}%</span>
      {savedTotal > 0 ? (
        <>
          {" "}
          · Saved:{" "}
          <span className="tw-font-semibold tw-text-primary">{formatPercentage(savedTotal)}%</span>
        </>
      ) : null}
      {pendingTotal > 0 ? (
        <>
          {" "}
          · Pending:{" "}
          <span className="tw-font-semibold">{formatPercentage(pendingTotal)}%</span>
        </>
      ) : null}
    </>
  );
};

export default IngredientCapacityStatus;
